import React from 'react';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import './AccumulatedSummaryResultsView.css';

const fmt = (value) =>
  Number(value || 0).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const DIM_PREFIX = {
  bank: 'Banque',
  group: 'Groupe',
  supervisor: 'Superviseur',
  lottery: 'Loterie',
  date: 'Date',
  global: null,
};

const AccumulatedSummaryResultsView = ({
  report, filter, displayMode, dateFrom, dateTo, generatedAt, onBack,
}) => {
  const { company } = useAuth();
  const blocks = report?.blocks || [];
  const dimKey = report?.display_mode || displayMode || 'global';
  const dimPrefix = DIM_PREFIX[dimKey];
  const companyName = report?.company_name || company?.name || '';

  const showCommission = ['pos', 'both'].includes(company?.commission_visibility);
  const showSavings = ['pos', 'both'].includes(company?.epargne_visibility);

  return (
    <Layout>
      <div className="asr-toolbar">
        <button className="asr-back" onClick={onBack}>◀ Retour</button>
        <button className="asr-print-btn" onClick={() => window.print()}>
          🖨 Imprimer
        </button>
      </div>

      <div className="asr-page asr-compact-page">
        {blocks.length === 0 && (
          <p className="asr-empty">Aucune vente sur cette période.</p>
        )}

        {blocks.map((block) => {
          const sales = Number(block.sales_total || 0);
          const winnings = Number(block.total_payed || 0);
          const result = sales - winnings;

          return (
            <section key={block.code} className="asr-group asr-compact-group">
              <header className="asr-compact-header">
                <div className="asr-brand">
                  {company?.logo && (
                    <img src={company.logo} alt="Logo" className="asr-logo" />
                  )}
                  <div>
                    <strong>{companyName || 'CGL'}</strong>
                    {dimPrefix && (
                      <div>
                        {dimPrefix}: {block.name || block.code}
                      </div>
                    )}
                  </div>
                </div>
                <div className="asr-compact-meta">
                  <div>{dateFrom} — {dateTo}</div>
                  <small>{generatedAt}</small>
                </div>
              </header>

              {filter && <p className="asr-compact-filter">{filter}</p>}

              <div className="asr-summary-grid">
                <div className="asr-summary-row">
                  <span>VENTES</span>
                  <strong>{fmt(sales)}</strong>
                </div>
                <div className="asr-summary-row">
                  <span>QTÉ PARIS</span>
                  <strong>{Number(block.bet_count || 0).toLocaleString('fr-FR')}</strong>
                </div>
                <div className="asr-summary-row">
                  <span>GAGNÉ</span>
                  <strong>{fmt(winnings)}</strong>
                </div>
                <div className={`asr-summary-row asr-result ${
                  result > 0 ? 'asr-result-positive' :
                  result < 0 ? 'asr-result-negative' : 'asr-result-even'
                }`}>
                  <span>RÉSULTAT{result > 0 ? ' — PROFIT' : result < 0 ? ' — PERTE' : ''}</span>
                  <strong>{fmt(result)}</strong>
                </div>

                {showCommission && (
                  <div className="asr-summary-row">
                    <span>COMMISSION</span>
                    <strong>{fmt(block.minus_sale_pct)}</strong>
                  </div>
                )}

                {showSavings && (
                  <div className="asr-summary-row">
                    <span>ÉPARGNE</span>
                    <strong>{fmt(block.savings_pct)}</strong>
                  </div>
                )}
              </div>
            </section>
          );
        })}
      </div>
    </Layout>
  );
};

export default AccumulatedSummaryResultsView;
